module.exports = __webpack_public_path__ + "static/media/Shox 01.3d74237a.png";